import moment from 'moment';

export const formatDate = (date: Date, momentFormat: string, inputFormat?: string) =>
  moment(date, inputFormat).format(momentFormat);
